<gl-wallet-loading-page-v1 *ngIf="!env.ENABLE_WALLET_V2; else version2"></gl-wallet-loading-page-v1>

<ng-template #version2>
    <gl-wallet-loading-page-v2></gl-wallet-loading-page-v2>
</ng-template>
